import { ContentResults } from "./components/contentResults/contentResults";
import { NumberOfHits } from "./components/numberOfHits/numberOfHits";
import { Pagination } from "./components/pagination/pagination";
import { ProductResults } from "./components/productsResults/productResults";
import { Title } from "./components/title/title";
import { Wrapper } from "./components/wrapper/wrapper.component";
import { Base } from "./results.base";

export const Results = Object.assign(Base, {
    Title: Title,
    NumberOfHits: NumberOfHits,
    Wrapper: Wrapper,
    ProductResults: ProductResults,
    ContentResults: ContentResults,
    Pagination: Pagination
});
